import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GroupForm from './GroupForm';
import { GroupInterface } from '../types';

interface CreateGroupModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: (groupData: Partial<GroupInterface>) => void;
}

function CreateGroupModal({ open, onClose, onCreate }: CreateGroupModalProps): React.JSX.Element {
  const handleCreate = (groupData: Partial<GroupInterface>): void => {
    onCreate(groupData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        יצירת קבוצה חדשה
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <GroupForm onCreate={handleCreate} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CreateGroupModal; 